import { render, staticRenderFns } from "./import-parts-inbound.vue?vue&type=template&id=7efbb3b6&scoped=true&"
import script from "./import-parts-inbound.vue?vue&type=script&lang=ts&"
export * from "./import-parts-inbound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efbb3b6",
  null
  
)

export default component.exports